import React from 'react';
import AssessQuestionnaire from "../../../assessCuestionnaire" 

const Index = () => {
  return <AssessQuestionnaire isDetail={true}/>
};

export default Index;
